(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ads-product-offers"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('phoenix-ad-offers')) {
  customElements.define('phoenix-ad-offers', class extends HTMLElement {
    connectedCallback() {
      const deadline = Date.parse(this.dataset.deadline);
      const timer = this.querySelector('.pa-offer__timer');
      const tick = () => {
        const now = Date.now();
        const remaining = deadline - now;
        const gift = this.querySelector('[data-gift-deadline]');
        if (gift) gift.hidden = now >= Date.parse(gift.dataset.giftDeadline);
        if (!Number.isFinite(remaining) || remaining <= 0) {
          this.hidden = true;
          clearInterval(this.interval);
          return false;
        }
        const total = Math.floor(remaining / 1000);
        const values = {days:Math.floor(total/86400),hours:Math.floor(total/3600)%24,minutes:Math.floor(total/60)%60,seconds:total%60};
        Object.entries(values).forEach(([unit,value])=>{this.querySelector('[data-unit="'+unit+'"]').textContent=String(value).padStart(2,'0');});
        timer.hidden = false;
        return true;
      };
      clearInterval(this.interval);
      if (tick()) this.interval = setInterval(tick,1000);
    }
    disconnectedCallback(){clearInterval(this.interval);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["thanksgiving-savings"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('phoenix-thanksgiving-offer'))customElements.define('phoenix-thanksgiving-offer',class extends HTMLElement{connectedCallback(){const update=()=>{const now=Date.now();this.hidden=now>=Date.parse(this.dataset.end);if(now>=Date.parse(this.dataset.start)){this.querySelector('[data-offer-status]').textContent=this.dataset.activeLabel;}if(this.hidden)clearInterval(this.offerInterval);};update();if(!this.hidden)this.offerInterval=setInterval(update,1000);}disconnectedCallback(){clearInterval(this.offerInterval);}});
  } catch(e) { console.error(e); }
})();

})();
